import { inject, Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { HttpService } from '@app/core/services/http.service';
import { environment } from '@environments/environment';
import { LIMIT_PER_PAGE_DEFAULT } from '@shared/shared.constants';
import { Bunker, InventorySupplyBody, NoonReportBody } from '@vessel-reports/noon/state/noon.types';
import { VesselReport } from '@vessel-reports/state/vessel-reports.types';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NoonService {
  public static readonly API: string = `${environment.PROJECT_API}/vessel-report-group/reports`;

  protected readonly httpService: HttpService = inject(HttpService);

  createNewReport(body: NoonReportBody): Observable<any> {
    return this.httpService.post<{
      data: any;
    }>(`${NoonService.API}`, body);
  }

  getDetailNoonReport(report_id: string): Observable<any> {
    return this.httpService.get<{
      data: any;
    }>(`${NoonService.API}/${report_id}`, {});
  }

  updateReport(report_id: string, body: any): Observable<any> {
    return this.httpService.put<{
      data: any;
    }>(`${NoonService.API}/${report_id}`, body);
  }

  updateDetailReport(body: any): Observable<any> {
    return this.httpService.post<{
      data: any;
    }>(`${NoonService.API}/details_bulk`, body);
  }

  submitReport(report_id: string): Observable<any> {
    return this.httpService.put<{
      data: any;
    }>(`${NoonService.API}/submit/${report_id}`, {});
  }

  deleteReport(report_id: string): Observable<any> {
    return this.httpService.delete(`${NoonService.API}/${report_id}`, {});
  }

  getPreviousReport(vessel_id: number, type?: number): Observable<any> {
    const url = type
      ? `${NoonService.API}/previous?filter[vessel_id]=${vessel_id}&filter[report_type_id]=${type}`
      : `${NoonService.API}/previous?filter[vessel_id]=${vessel_id}`;
    return this.httpService.get<{
      data: VesselReport;
    }>(url, {});
  }

  getInventoriesSupply(report_id: string): Observable<any> {
    return this.httpService.get<{
      data: VesselReport;
    }>(`${NoonService.API}/supplies/${report_id}`, {});
  }

  createInventorySupply(body: InventorySupplyBody): Observable<any> {
    return this.httpService.post<{
      data: any;
    }>(`${NoonService.API}/supplies`, body);
  }

  updateInventorySupply(id: string, body: InventorySupplyBody): Observable<any> {
    return this.httpService.put<{
      data: any;
    }>(`${NoonService.API}/supplies/${id}`, body);
  }

  deleteInventorySupply(id: string) {
    return this.httpService.delete(`${NoonService.API}/supplies/${id}`, {});
  }

  createReportBunker(body: any): Observable<any> {
    return this.httpService.post<{
      data: any;
    }>(`${NoonService.API}/bunkers`, body);
  }

  updateReportBunker(report_id: string, body: any): Observable<any> {
    return this.httpService.put<{
      data: any;
    }>(`${NoonService.API}/bunkers/${report_id}`, body);
  }

  deleteReportBunker(report_id: string): Observable<any> {
    return this.httpService.delete(`${NoonService.API}/bunkers/${report_id}`, {});
  }

  getBunker(bunker_id: string): Observable<any> {
    return this.httpService.get<{
      data: Bunker;
    }>(`${NoonService.API}/bunkers/${bunker_id}`, {});
  }

  getAdvanceFilters(key: string, limit?: number, queryParams?: Params): Observable<{ data: any[] }> {
    return this.httpService.get<{ data: any[] }>(`${NoonService.API}/advance_filters`, {
      params: {
        advance_filter: key,
        limit: limit ?? LIMIT_PER_PAGE_DEFAULT,
        ...queryParams
      }
    });
  }
}
